module.exports = __webpack_public_path__ + "static/media/YM86_1.aa258412.jpg";